import { render, staticRenderFns } from "./Raccoltapunti.vue?vue&type=template&id=30a0cc10"
import script from "./Raccoltapunti.vue?vue&type=script&lang=js"
export * from "./Raccoltapunti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports